import React, { Suspense, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useDispatch } from 'react-redux';

import {
  Loader,
} from '../../components';
import { setSetUtmCookies } from '../../helpers/utm';
import { utmCookiesSet } from '../../actions/UI';

import './leaflet.css';
import './style.scss';

const ProjectMap = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    setSetUtmCookies();
    dispatch(utmCookiesSet());
  }, [dispatch]);

  // Lazy-load ProjectMap with a delay.
  const ProjectMap = React.lazy(() => {
    return new Promise((resolve) => {
      setTimeout(() => resolve(import('./Map')), 1500);
    });
  });

  return (
    <Suspense fallback={<Loader inline loading />}>
      <ProjectMap {...props} />
    </Suspense>
  );
};

export default withRouter(ProjectMap);
